import { localStore } from "./localStore";
export const initialPlayers = [
    {
        id: 0,
        name: "",
    },
];
export const initialScores = [
    [
        {
            id: 0,
            points: 0,
        },
    ],
];
export const initialRoundToEdit = 1;
export const players = localStore("score-keeper-players", initialPlayers);
export const scores = localStore("score-keeper-scores", initialScores);
export const roundToEdit = localStore("score-keeper-roundToEdit", initialRoundToEdit);
